import { getAffectationProduitReseauTempo } from '@/api/affectation/index';
import {
  TYPE_DEVIS, ETAT_ENREGISTRE, ETAT_COMMANDE_PARTIELLEMENT,
  ETAT_BROUILLON,
} from '@/configuration/devisConf';
import {
  BLOQUE,
  RELANCE_OPTION,
  OPTION,
} from '@/configuration/optionBlocage/optionBlocage';
import i18n from '@/i18n';

function getAffectation(allAffectations, etatObtenu, referenceType, referenceEtat, rang) {
  let finalAffectation = null;
  allAffectations.filter((affectation) => {
    return affectation.etatObtenu === etatObtenu
    && affectation.typeReference === referenceType
    && affectation.etatReference === referenceEtat
    && affectation.rangOption === rang;
  }).forEach((affectation) => {
    if (!finalAffectation
      || affectation.nbFaces > finalAffectation.nbFaces
      || (affectation.nbFaces === finalAffectation.nbFaces
        && finalAffectation.libelle.localeCompare(affectation.libelle)) > 0) {
      finalAffectation = affectation;
    }
  });
  return finalAffectation;
}

function getAnnonceurBloquer(affectationsReseau, anneeSemaine) {
  const allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine
      && affectation.etatObtenu === BLOQUE;
  });
  if (allAffectations.length === 0) return null;
  if (allAffectations.length > 1) return i18n.t('dcf.annonceur', { nbAnnonceur: allAffectations.length });
  return allAffectations[0].libelle;
}

function getNpr(affectationsReseau, anneeSemaine) {
  let allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine
      && affectation.etatObtenu === BLOQUE;
  });
  if (allAffectations.length >= 1) {
    return allAffectations[0].nePasReafficher ? allAffectations[0].nePasReafficher : false;
  }
  allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine
      && affectation.etatObtenu === RELANCE_OPTION;
  });
  if (allAffectations.length >= 1) {
    return allAffectations[0].nePasReafficher ? allAffectations[0].nePasReafficher : false;
  }
  allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine
      && affectation.etatObtenu === OPTION && affectation.rangOption === 1;
  });
  if (allAffectations.length >= 1) {
    return allAffectations[0].nePasReafficher ? allAffectations[0].nePasReafficher : false;
  }
  allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine;
  });
  if (allAffectations.length >= 1) {
    return allAffectations[0].nePasReafficher ? allAffectations[0].nePasReafficher : false;
  }
  return false;
}

function getAnnonceur(affectationsReseau, anneeSemaine) {
  const allAffectations = affectationsReseau.filter((affectation) => {
    return anneeSemaine === affectation.anneSemaine;
  });
  if (allAffectations.length === 0) return null;
  let affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_ENREGISTRE, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_BROUILLON, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_ENREGISTRE, 1);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, 1);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_BROUILLON, 1);
  return affectationFind ? affectationFind.libelle : null;
}

export default async function loadAffectationReseauTempo(listReseauTempo) {
  if (listReseauTempo.length === 0) return;
  const listAffectationInformation = [];
  listReseauTempo.forEach((reseau) => {
    const informationAffectation = { id: reseau.id, anneeSemaines: [] };
    reseau.dispo.forEach((disponibilite) => {
      informationAffectation.anneeSemaines.push(disponibilite.anneeSemaine);
    });
    listAffectationInformation.push(informationAffectation);
  });
  const affectation = (
    await getAffectationProduitReseauTempo(listAffectationInformation, true)
  ).data.result;
  listReseauTempo.forEach((reseauTempo) => {
    reseauTempo.dispo.forEach((disponibilite) => {
      disponibilite.nePasReafficher = getNpr(
        affectation[reseauTempo.id],
        disponibilite.anneeSemaine,
      );
      disponibilite.annonceur = getAnnonceurBloquer(
        affectation[reseauTempo.id],
        disponibilite.anneeSemaine,
      );
      if (!disponibilite.annonceur) {
        disponibilite.annonceur = getAnnonceur(
          affectation[reseauTempo.id], disponibilite.anneeSemaine,
        );
      }
      disponibilite.allAffectationOfProduct = affectation[reseauTempo.id].filter((affectation) => {
        return disponibilite.anneeSemaine === affectation.anneSemaine;
      });
    });
  });
}
